module.exports = "<div class=\"main-content\">\n\t<div class=\"buttons\">\n\t\t<a [routerLink]=\"['/ventas/asignar-cajero/crear']\" class=\"btn btn-info btn-fill\">\n\t\t\t<i class=\"fa fa-plus\"></i>\n\t\t\tNuevo\n\t\t</a>\n\t</div>\n\t<br>\n\n\t<grid [dataGrid]=\"dataGrid\"></grid>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/ventas/cajero-asignar-list/cajero-asignar-list.component.html
// module id = ../../../../../src/app/components/ventas/cajero-asignar-list/cajero-asignar-list.component.html
// module chunks = main